module.exports = __webpack_public_path__ + "img/banner-ru.ca7b7f6.jpg";